import Constants from '../constants/Index';
import { ElMessage } from 'element-plus';
import { storageFactory } from "./LocalstorageFactory";

const local = storageFactory(() => localStorage);
//const session = storageFactory(() => sessionStorage);

function formatTime(time: string) {
  return time.substring(0, 16)
}

function successMsg(message: string) {
  ElMessage({
    type: 'success',
    message
  })
}

function warningMsg(message: string) {
  ElMessage({
    type: 'warning',
    message
  })
}

//IE10 以上支持
function Base64Encode(str: string) {
  console.log(str);
  return btoa(encodeURIComponent(str));
}
//IE10 以上支持
function Base64Decode(str: string) {
  return decodeURIComponent(atob(str));
}

function setLocalStore(key: string, value: string) {
  local.setItem(key, Base64Encode(value))
}

function getLocalStore(key: string) {
  const value = local.getItem(key);
  if (value !== null) {
    return Base64Decode(value);
  }
  return "";
}
function clearLocalStore() {
  local.clear();
}

function isLogin() {
  if (getLocalStore(Constants.TokenKey)) {
    return true;
  }
  return false;
}

function getLoginUserId() {
  if (!isLogin) return null;
  const userInfoStr = getLocalStore(Constants.PhoneKey);
  if (userInfoStr) {
    const userInfo = JSON.parse(userInfoStr);
    return userInfo.id;
  }
  return null;
}

function getQiniuVframe(url:string,index = 1) {
  return url + '?vframe/jpg/offset/' + index
}

const CommonUtils = {
  formatTime,
  successMsg,
  warningMsg,
  setLocalStore,
  getLocalStore,
  clearLocalStore,
  isLogin,
  getLoginUserId,
  Base64Encode,
  Base64Decode,
  getQiniuVframe
};


export default CommonUtils;